import $ from "jquery";

const selectors = {
  fixedMessage: ".js-fixed-message",
  section: ".js-section",
};

const states = {
  active: "is-active",
};

let $window;
let $fixedMessage;
let $section;
let sectionHeight;

const onScroll = function () {
    sectionHeight = $section.outerHeight();
    const scrollPos = $window.scrollTop();

    if (scrollPos >= sectionHeight) {
        $fixedMessage.addClass(states.active);
    } else {
        $fixedMessage.removeClass(states.active);
    }

    if (!$fixedMessage.hasClass(states.active)) {
        return;
    }
};

const fixedMessage = function () {
    $window = $(window);
    $fixedMessage = $(selectors.fixedMessage);
    $section = $(selectors.section);

    if (!$fixedMessage.length) {
        return;
    }

    if (!$section.length) {
        return;
    }

    sectionHeight = $section.outerHeight();

    if ($window.scrollTop() >= sectionHeight) {
        $fixedMessage.addClass(states.active);
    }

    $window.on('scroll', onScroll);
};

export default fixedMessage;
